import { ImageItem, ProductMetafields } from "~/types";
import { myRegistryApp } from "../../../../setup/settings/__product";

export default function MyRegistryButton({ product, showPrice }: { product: ProductMetafields, showPrice: (n?: boolean) => number }) {

    const images: ImageItem[] = product.images?.value != null ? JSON.parse(product.images?.value) : [];

    const showPopup = () => {
        var gift = {
            Title: product.title,
            ImageUrl: images[0].Src,
            URL: myRegistryApp.url + product.handle,
            Price: showPrice(true),
            Quantity: 1, //Data Type: Int
            // Color: 'Grey/Orange', //Data Type: String
            // Size: '3 Person', //Data Type: String
            HideSize: true,
            SKU: product.handle, //Data Type: String
            // Options: '[{"Length": "22"}, {"Shape": "Round"}, {"Size": "Big"}]' //Data Type: JSON
        };
        var myregistrysdk = new MyRegistrySDK(gift);
        if (myregistrysdk) myregistrysdk.showPopup();
    }

    return (
        <div className="customize-button mt-4" onClick={showPopup}>Add to Registry</div>
    )
}